import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface SectionHeaderProps {
  className?: string;
  children: ReactNode;
}

export const SectionHeader: FC<SectionHeaderProps> = ({
  className,
  children,
}) => {
  const headerClassName = clsx(
    'vtmn-flex vtmn-items-center vtmn-mb-2',
    className
  );
  return (
    <header data-testid="section-header-component" className={headerClassName}>
      {children}
    </header>
  );
};
